<template>
  <modal
    name="questions-start-tour-modal"
    :adaptive="true"
    :classes="['questions-start-tour-modal']"
    :click-to-close="false"
    :height="'auto'"
    :scrollable="true"
  >
    <button
      class="close"
      @click="hide()"
    >
      <icon
        name="cross"
        variant="b3b3b3"
      />
    </button>
    <div class="emoji">
      👋
    </div>
    <h2 class="title">
      Welcome, {{ userFirstName }}!
    </h2>
    <p class="text">
      We’ll show you how to study smarter—saving you time and stress. Don’t worry, it will only take a few minutes!
    </p>
    <p class="text">
      <strong>
        Let’s begin by answering some questions.
      </strong>
    </p>
    <button
      class="start-button"
      @click="triggerStart()"
    >
      Let's Go!
    </button>
  </modal>
</template>

<script>
import Icon from '@components/singletons/icon';
import QuestionsUIV2Mixin from '@/mixins/questions-ui-v2';

import { startTour } from '@/utils/tour';

export default {
  components: { Icon },
  mixins: [QuestionsUIV2Mixin],
  computed: {
    userFirstName() {
      const user = this.$store.getters['user/get'];
      return user?.firstName;
    },
  },
  methods: {
    hide() {
      this.$store.commit('session/scheduleTour', false);
      this.$modal.hide('questions-start-tour-modal');
    },
    triggerStart() {
      return startTour.apply(this);
    },
  },
};
</script>

<style lang='scss'>
  .questions-start-tour-modal {
    background-color: #001c74;
    border-radius: rem-calc(6);
    padding: rem-calc(32);
    position: relative;
    text-align: center;

    @include breakpoint(small) {
      max-width: 98%;
      margin-left: 1%;
      padding: rem-calc(16) rem-calc(16);
    }

    .emoji {
      font-size: rem-calc(40);
      margin-bottom: rem-calc(16);
    }

    .title {
      font-size: rem-calc(32);
      line-height: 1.35;
      margin: 0 auto rem-calc(24) auto;
      max-width: rem-calc(320);
      color: #ffffff;
    }

    .text {
      font-size: rem-calc(16);
      color: #ffffff;
      line-height: 1.25;
      max-width: rem-calc(460);
      margin: 0 auto rem-calc(24);
      &:first-of-type {
        margin-bottom: 0;
      }

      @include breakpoint(small) {
        margin-bottom: rem-calc(40);
      }
    }

    .start-button {
      background-color: #00d8f8;
      border-radius: rem-calc(24);
      color: #ffffff;
      width: rem-calc(165);
      font-size: rem-calc(20);
      font-weight: $semi-bold;
      margin: rem-calc(44) auto rem-calc(16);
      padding: rem-calc(15) rem-calc(24);
      display: block;

      @include breakpoint(small) {
        margin-top: rem-calc(40);
      }
    }

    .close {
      right: rem-calc(6);
      position: absolute;
      top: rem-calc(6);
      background: transparent;
      border: none;
      padding: 0;
      opacity: 0.4;

      @include breakpoint(small) {
        right: rem-calc(4);
      }

      img {
        height: rem-calc(16);
        width: rem-calc(16);

        @include breakpoint(small) {
          height: rem-calc(20);
          width: rem-calc(20);
        }
      }
    }
  }
</style>
